import { render, staticRenderFns } from "./CreateEditCompanyForm.vue?vue&type=template&id=8f7c1e84"
import script from "./CreateEditCompanyForm.vue?vue&type=script&lang=ts"
export * from "./CreateEditCompanyForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports